import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BookingStatus } from '@contact/upgrade';

import { AgentBookingMailAcceptingComponent } from './accepting/agent-booking-mail-accepting.component';
import { AgentBookingMailAllocatedComponent } from './allocated/agent-booking-mail-allocated.component';
import { AgentBookingMailInprocessAcceptReviewComponent } from './inprocess-accept-review/agent-booking-mail-inprocess-accept-review.component';
import { AgentBookingMailInprocessAnswerAskForHelpComponent } from './inprocess-answer-ask-for-help/agent-booking-mail-inprocess-answer-ask-for-help.component';
import { AgentBookingMailInprocessAskForHelpComponent } from './inprocess-ask-for-help/agent-booking-mail-inprocess-ask-for-help.component';
import { AgentBookingMailInprocessAssistComponent } from './inprocess-assist/agent-booking-mail-inprocess-assist.component';
import { AgentBookingMailInprocessCloseComponent } from './inprocess-close/agent-booking-mail-inprocess-close.component';
import { AgentBookingMailInprocessDelegateComponent } from './inprocess-delegate/agent-booking-mail-inprocess-delegate.component';
import { AgentBookingMailInprocessForwardComponent } from './inprocess-forward/agent-booking-mail-inprocess-forward.component';
import { AgentBookingMailInprocessKnowledgeComponent } from './inprocess-knowledge/agent-booking-mail-inprocess-knowledge.component';
import { AgentBookingMailInprocessRejectReviewComponent } from './inprocess-reject-review/agent-booking-mail-inprocess-reject-review.component';
import { AgentBookingMailInprocessReviewComponent } from './inprocess-review/agent-booking-mail-inprocess-review.component';
import { AgentBookingMailInprocessComponent } from './inprocess/agent-booking-mail-inprocess.component';
import { AgentBookingMailQualificationComponent } from './qualification/agent-booking-mail-qualification.component';

export enum AgentBookinMailInprocessState {
  send = 'send',
  close = 'close',
  delegate = 'delegate',
  forward = 'forward',
  review = 'review',
  acceptReview = 'accept-review',
  rejectReview = 'reject-review',
  askForHelp = 'ask-for-help',
  answerAskForHelp = 'answer-ask-for-help',
  assist = 'assist',
  knowledge = 'knowledge',
}

const routes: Routes = [
  {
    path: BookingStatus.ACCEPTING.toLowerCase(),
    component: AgentBookingMailAcceptingComponent,
  },
  {
    path: BookingStatus.ALLOCATED.toLowerCase(),
    component: AgentBookingMailAllocatedComponent,
  },
  {
    path: BookingStatus.IN_PROCESS.toLowerCase(),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: AgentBookinMailInprocessState.send,
      },
      {
        path: AgentBookinMailInprocessState.send,
        component: AgentBookingMailInprocessComponent,
      },
      {
        path: AgentBookinMailInprocessState.close,
        component: AgentBookingMailInprocessCloseComponent,
      },
      {
        path: AgentBookinMailInprocessState.delegate,
        component: AgentBookingMailInprocessDelegateComponent,
      },
      {
        path: AgentBookinMailInprocessState.forward,
        component: AgentBookingMailInprocessForwardComponent,
      },
      {
        path: AgentBookinMailInprocessState.review,
        component: AgentBookingMailInprocessReviewComponent,
      },
      {
        path: AgentBookinMailInprocessState.answerAskForHelp,
        component: AgentBookingMailInprocessAnswerAskForHelpComponent,
      },
      {
        path: AgentBookinMailInprocessState.askForHelp,
        component: AgentBookingMailInprocessAskForHelpComponent,
      },
      {
        path: AgentBookinMailInprocessState.acceptReview,
        component: AgentBookingMailInprocessAcceptReviewComponent,
      },
      {
        path: AgentBookinMailInprocessState.rejectReview,
        component: AgentBookingMailInprocessRejectReviewComponent,
      },
      {
        path: AgentBookinMailInprocessState.assist,
        component: AgentBookingMailInprocessAssistComponent,
      },
      {
        path: AgentBookinMailInprocessState.knowledge,
        component: AgentBookingMailInprocessKnowledgeComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
  {
    path: BookingStatus.POST_PROCESSING.toLowerCase(),
    component: AgentBookingMailQualificationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentBookingMailRoutingModule {}
